import { render, staticRenderFns } from "./SecurityData.vue?vue&type=template&id=2caef9e6"
import script from "./SecurityData.vue?vue&type=script&lang=js"
export * from "./SecurityData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports